<template>
  <div>
    <common-dialog ref="dialog" width="500px" title="开工时间" id-key="UserId" :data="data" @edit-opened="opened" @close-saved="$emit('close-saved')">
      <template slot="form">
        <div>
          <el-row class="border">
            <el-row :gutter="15">
              <el-col>
                <el-form-item label="开工时间">
                  <el-date-picker v-model="data.StartDate" type="datetime" placeholder="选择日期时间" :picker-options="pickerOptions"> </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-row>
        </div>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="closeDialog">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  props: {
    type: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      api: require('@/api/pu/plan').default,
      data: {
        PlanIds: [],
        StartDate: ''
      },
      time: '',
      order: '',
      name: '',
      schedulingDates: [],
      timeList: [],
      pickerOptions: {
        disabledDate: time => {
          let bool = false
          let year = time.getFullYear()
          let month = time.getMonth() + 1
          let day = time.getDate()

          console.log('selectableRange', this.pickerOptions.selectableRange, this.schedulingDates)
          let t = `${year}/${month}/${day}`
          let index = this.schedulingDates.indexOf(t)
          if (index === -1) {
            bool = true
          }
          console.log(t, index, 't')

          return bool
        }
      }
    }
  },
  created() {
    this.api.schedulingDateRange({ SchedulingType: 1 }).then(res => {
      if (res.Code === 0) {
        this.timeList = res.Data
        this.schedulingDates = this.timeList.map(item => {
          return item.SchedulingDate
        })

        if (this.timeList.length > 0) {
          console.log(this.timeList, 'this.timeList ')
          this.pickerOptions.selectableRange = `${this.timeList[0].SchedulingTimeRanges[0].SchedulingStartTime}:00 - ${this.timeList[0].SchedulingTimeRanges[0].SchedulingEndtTime}:00`
        }
      }
    })
  },
  methods: {
    save() {
      var loading = this.$loading({
        lock: true,
        text: '正在保存...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      this.api
        .changeStartDate(this.data)
        .then(res => {
          if (res.Code === 0) {
            console.log('res.Data', res.Data)
            this.$message({ type: 'success', message: res.Msg })
            this.$emit('changeTime', this.data)
            loading.close()
            this.close(true)
          } else {
            this.$message({ type: 'warning', message: res.Msg })
            loading.close()
          }
        })
        .catch(err => {
          console.error(err)
          loading.close()
        })
    },
    opened(row) {
      this.data.PlanIds = row.PlanIds
      this.data.StartDate = row.StartDate
    },
    closeDialog() {
      this.close()
    }
  }
}
</script>
